// extracted by mini-css-extract-plugin
export default {"error_container":"Error_error_container__rVkFS"};